import React from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, Dropdown, TextField } from '@carsys/form'
import { Grid } from '@mui/material'

export interface IDropdownOption {
  key: string
  text: string
  value: string
}
export interface SubgroupName {
  options: IDropdownOption[] | null
}

export const SubgroupName: React.FC<SubgroupName> = ({ options }) => {
  const { t } = useTranslation()

  if (!options) {
    return null
  }

  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={4}>
        <TextField required label={t('productgroup.name')} name='Name' fullWidth sx={{ mb: '1em' }} />
        <Checkbox name='IsActive' label={t('productgroup.is_active')} />
      </Grid>
      <Grid item xs={4}>
        <Dropdown label={t('productgroup.linked_maingroup')} name='LinkedMainGroup' fullWidth options={options} />
      </Grid>
    </Grid>
  )
}

SubgroupName.displayName = 'SubgroupName'

export default SubgroupName
